var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('main', {
    staticClass: "main page_students_create"
  }, [_c('h1', {
    staticClass: "title--page"
  }, [_vm._v(" " + _vm._s(_vm.studentAddress) + "・保護者情報" + _vm._s(_vm.id ? "編集" : "作成") + " ")]), _vm.isLoading.getData ? _c('loading-message') : _vm._e(), _vm.isLoading.postData ? _c('loading-message', {
    attrs: {
      "loading-message": _vm.loadingMessage
    }
  }) : _vm._e(), _c('form', {
    staticClass: "common_form",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('row-item', {
    staticClass: "start students_item"
  }, [_c('p', {
    staticClass: "required col_3"
  }, [_vm._v("学年")]), _c('div', {
    staticClass: "col_9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.grade_id,
      expression: "student.grade_id"
    }],
    staticClass: "common_form--select col_5",
    attrs: {
      "id": "grade",
      "name": "class"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.student, "grade_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.grades, function (grade, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": grade.id
      }
    }, [_vm._v(" " + _vm._s(grade.name) + " ")]);
  }), 0), _vm.error.grade_id ? _c('p', {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.error.grade_id) + " ")]) : _vm._e()])]), _c('row-item', {
    staticClass: "start students_item"
  }, [_c('p', {
    staticClass: "required col_3"
  }, [_vm._v("クラス")]), _c('div', {
    staticClass: "col_9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.class_id,
      expression: "student.class_id"
    }],
    staticClass: "common_form--select col_5",
    attrs: {
      "id": "class",
      "name": "class"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.student, "class_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.classroomList, function (classroom, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": classroom.id
      }
    }, [_vm._v(" " + _vm._s(classroom.name) + " ")]);
  }), 0), _vm.error.class_id ? _c('p', {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.error.class_id) + " ")]) : _vm._e()])]), _c('row-item', {
    staticClass: "start students_item"
  }, [_c('p', {
    staticClass: "required col_3"
  }, [_vm._v(_vm._s(_vm.studentAddress) + "氏名")]), _c('div', {
    staticClass: "col_9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.name,
      expression: "student.name"
    }],
    staticClass: "common_form--input col_12",
    attrs: {
      "type": "text",
      "placeholder": "山田 太郎"
    },
    domProps: {
      "value": _vm.student.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.student, "name", $event.target.value);
      }
    }
  }), _vm.error.name ? _c('p', {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.error.name) + " ")]) : _vm._e()])]), _c('row-item', {
    staticClass: "start students_item"
  }, [_c('p', {
    staticClass: "required col_3"
  }, [_vm._v("ふりがな")]), _c('div', {
    staticClass: "col_9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.ruby,
      expression: "student.ruby"
    }],
    staticClass: "common_form--input col_12",
    attrs: {
      "type": "text",
      "placeholder": "やまだ たろう"
    },
    domProps: {
      "value": _vm.student.ruby
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.student, "ruby", $event.target.value);
      }
    }
  }), _vm.error.ruby ? _c('p', {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.error.ruby) + " ")]) : _vm._e()])]), _c('row-item', {
    staticClass: "start students_item"
  }, [_c('p', {
    staticClass: "col_3"
  }, [_vm._v("性別")]), _c('div', {
    staticClass: "col_9"
  }, [_c('row-item', [_c('div', {
    staticClass: "col_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.gender,
      expression: "student.gender"
    }],
    staticClass: "common_form--radio",
    attrs: {
      "id": "genderBoy",
      "type": "radio",
      "name": "gender"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.student.gender, 1)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.student, "gender", 1);
      }
    }
  }), _c('label', {
    staticClass: "common_form--label",
    attrs: {
      "for": "genderBoy"
    }
  }, [_vm._v("男")])]), _c('div', {
    staticClass: "col_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.student.gender,
      expression: "student.gender"
    }],
    staticClass: "common_form--radio",
    attrs: {
      "id": "genderGirl",
      "type": "radio",
      "name": "gender"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.student.gender, 2)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.student, "gender", 2);
      }
    }
  }), _c('label', {
    staticClass: "common_form--label",
    attrs: {
      "for": "genderGirl"
    }
  }, [_vm._v("女")])])])], 1)]), _c('section', {
    staticClass: "common_form__button_wrap"
  }, [_c('input', {
    staticClass: "cancel_button",
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }), _vm.id ? _c('input', {
    staticClass: "update_button",
    attrs: {
      "type": "button",
      "value": "更新する"
    },
    on: {
      "click": _vm.saveData
    }
  }) : _c('input', {
    staticClass: "register_button",
    attrs: {
      "type": "button",
      "value": "登録する"
    },
    on: {
      "click": _vm.saveData
    }
  })])], 1), _vm.showModal ? _c('message-modal', {
    on: {
      "close": _vm.completeCreate
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };